const zh = {
  header: {
    tip1:
      "为了防止系统误关闭您的虚拟空间中正在进行的游戏，导致您的游戏在未知情况下被掉线中断，需要您手动按照以下步骤完成设置。",
  },
  content: {
    list1: {
      title: "多进程管理状态时，将虚拟大师添加【锁定】，保持后台可运行。",
    },
    list2: {
      title1:
        "确保手机内存充足，如果本机运行内存不足，系统会自动清理进程，即便是加锁应用程序也有可能被清理。",
      title2: "建议您在虚拟空间运行期间，主动清理多余的后台应用。",
    },
  },
};

export default zh;
